import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
  Switch,
  TableSortLabel,
  Typography,
} from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import ImportPlatformModal from 'components/admin/platform/ImportPlatformModal';
import _ from 'lodash';
import { useState } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { toast } from 'react-toastify';
import useSWR from 'swr';
import { exportPlatformList, getPlatformList, updatePlatformById } from '../../../api/cms/platform';
import CreatePlatFormModal from '../../../components/admin/platform/CreatePlatFormModal';
import Breadcrumbs from '../../../components/Breadcrumbs';
import ApplicationLayout from '../../../components/layouts/ApplicationLayout';
import { LoadingBox } from '../../../components/LoadingBox';

const PlatformList = () => {
  let match = useRouteMatch();
  const [platformActive, setPlatformActive] = useState(false);
  const [platformId, setPlatformId] = useState();
  const [checkedList, setCheckedList] = useState([]);
  const [importOpen, setImportOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { data, error, mutate } = useSWR(['getPlatformList', platformActive, platformId], () =>
    getPlatformList(),
  );
  const [sortBy, setSortBy] = useState('platform_name');
  const [sortDir, setSortDir] = useState('asc');

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortBy(field);
      setSortDir('asc');
    }
  };

  const sortedData = _.orderBy(data || [], [sortBy], [sortDir]);
  const canExport = checkedList.length > 0;

  const handleCheckboxChange = (platformCode) => (event) => {
    if (event.target.checked) {
      setCheckedList((prev) => [...prev, platformCode]);
    } else {
      setCheckedList((prev) => prev.filter((code) => code !== platformCode));
    }
  };
  const isAllChecked = data && checkedList.length === data.length && data.length > 0;
  const isIndeterminate = data && checkedList.length > 0 && checkedList.length < data.length;

  const handleSelectAllChange = (event) => {
    if (event.target.checked) {
      setCheckedList(data.map((row) => row.platform_code));
    } else {
      setCheckedList([]);
    }
  };

  const handleExport = () => {
    if (checkedList.length === 0) {
      toast.error('Please select at least one platform to export.');
      return;
    }
    setIsLoading(true);
    exportPlatformList(checkedList)
      .then(() => {
        toast.success('Export successful. Please check your downloads.');
      })
      .catch((error) => {
        console.error('Export failed:', error);
        toast.error('Export failed. Please try again.');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (error) toast.error('error');

  const onActiveChange = (is_active, id) => {
    console.log('isactive : ', is_active);
    console.log('id : ', id);
    console.log('platformId : ', platformId);

    updatePlatformById(id, { is_active })
      .then(() => {
        setPlatformId(id);
        setPlatformActive(is_active);
        toast.success('updated');
      })
      .catch((error) => {
        toast.error('can not updated');
      });
  };

  return (
    <ApplicationLayout>
      {!data || isLoading ? (
        <LoadingBox />
      ) : (
        <>
          <Breadcrumbs />
          <Typography variant="h6" gutterBottom component="div">
            Platform List
          </Typography>
          <Box sx={{ mb: 2 }}>
            <Grid display="flex" justifyContent="flex-end" container spacing={4}>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={false}
                  onClick={() => setImportOpen(true)}
                >
                  Import
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!canExport || isLoading}
                  onClick={handleExport}
                >
                  Export
                </Button>
              </Grid>
            </Grid>
          </Box>
          <TableContainer component={Paper}>
            <Table aria-label="user table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Checkbox
                      checked={isAllChecked}
                      indeterminate={isIndeterminate}
                      onChange={handleSelectAllChange}
                    />
                  </TableCell>
                  {[
                    { label: 'Platform Name', field: 'platform_name' },
                    { label: 'Platform Code', field: 'platform_code' },
                    { label: 'Merchant Code', field: 'merchant_code' },
                    { label: 'Email', field: 'email' },
                    { label: 'Active', field: 'is_active' },
                  ].map(({ label, field }) => (
                    <TableCell key={field} sortDirection={sortBy === field ? sortDir : false}>
                      <TableSortLabel
                        active={sortBy === field}
                        direction={sortBy === field ? sortDir : 'asc'}
                        onClick={() => handleSort(field)}
                      >
                        {label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                  <TableCell>Action</TableCell>
                  <TableCell>Player</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Checkbox
                        checked={checkedList.includes(row.platform_code)}
                        onChange={handleCheckboxChange(row.platform_code)}
                      />
                    </TableCell>
                    <TableCell>{row.platform_name}</TableCell>
                    <TableCell>{row.platform_code}</TableCell>
                    <TableCell>{row.merchant_code}</TableCell>
                    <TableCell>
                      <a href={`mailto:${row.email}`}>{row.email}</a>
                    </TableCell>
                    <TableCell>
                      {row.is_active != null ? (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={row.is_active}
                              onChange={(event) => {
                                // setPlatformId(row.user_id);
                                onActiveChange(event.target.checked, row.user_id);
                              }}
                            />
                          }
                        />
                      ) : null}
                    </TableCell>
                    <TableCell>
                      <Link to={`platform_list/${row.user_id}`}>
                        <Button variant="contained" color="secondary">
                          <ExitToAppIcon />
                        </Button>
                      </Link>
                    </TableCell>
                    <TableCell>
                      <Link to={`player_list/${row.platform_code}`}>
                        <Button variant="contained" color="primary">
                          <RemoveRedEyeIcon />
                        </Button>
                      </Link>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
      <CreatePlatFormModal onSubmitSuccess={() => mutate()} />
      <ImportPlatformModal
        open={importOpen}
        onClose={() => setImportOpen(false)}
        onSuccess={() => {
          mutate();
        }}
        existingPlatforms={data}
      />
    </ApplicationLayout>
  );
};

export default PlatformList;
